/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Successfully_Extracted_ListingInputs */

const en_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully extracted listing details`)
};

const es_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del anuncio extraídos con éxito`)
};

const fr_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l'annonce extraits avec succès`)
};

const de_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Details erfolgreich extrahiert`)
};

const ja_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品の詳細が正常に抽出されました`)
};

const zh_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功提取商品详情`)
};

const ar_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم استخراج تفاصيل الإعلان بنجاح`)
};

const id_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil mengekstrak detail listing`)
};

const it_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli dell'annuncio estratti con successo`)
};

const ru_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали объявления успешно извлечены`)
};

const pt_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do anúncio extraídos com sucesso`)
};

const ko_successfully_extracted_listing = /** @type {(inputs: Successfully_Extracted_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 세부 정보를 성공적으로 추출했습니다`)
};

/**
* | output |
* | --- |
* | "Successfully extracted listing details" |
*
* @param {Successfully_Extracted_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const successfully_extracted_listing = /** @type {((inputs?: Successfully_Extracted_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Successfully_Extracted_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_successfully_extracted_listing(inputs)
	if (locale === "es") return es_successfully_extracted_listing(inputs)
	if (locale === "fr") return fr_successfully_extracted_listing(inputs)
	if (locale === "de") return de_successfully_extracted_listing(inputs)
	if (locale === "ja") return ja_successfully_extracted_listing(inputs)
	if (locale === "zh") return zh_successfully_extracted_listing(inputs)
	if (locale === "ar") return ar_successfully_extracted_listing(inputs)
	if (locale === "id") return id_successfully_extracted_listing(inputs)
	if (locale === "it") return it_successfully_extracted_listing(inputs)
	if (locale === "ru") return ru_successfully_extracted_listing(inputs)
	if (locale === "pt") return pt_successfully_extracted_listing(inputs)
	return ko_successfully_extracted_listing(inputs)
});